/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookmarkCrossFill: {
  name: 'bookmark-cross-fill';
  data: string;
} = {
  name: 'bookmark-cross-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5A1.5 1.5 0 0 0 1.5 2v11.538a1.5 1.5 0 0 0 2.044 1.398l4.275-1.662a.5.5 0 0 1 .362 0l4.275 1.662a1.5 1.5 0 0 0 2.044-1.398V2A1.5 1.5 0 0 0 13 .5H3Zm7.354 4.854a.5.5 0 0 0-.708-.708L8 6.293 6.354 4.646a.5.5 0 1 0-.708.708L7.293 7 5.646 8.646a.5.5 0 1 0 .708.708L8 7.707l1.646 1.647a.5.5 0 0 0 .708-.708L8.707 7l1.647-1.646Z" fill="currentColor"/></svg>`,
};
